import { Box, Typography, Tabs, Tab } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { RequestedListing } from './requestedlisting/Index';
import { Inquiries } from './inquiries/Index';
import { AgentApplication } from './agentapplication/Index';
import { MyPropertyListing } from './mypropertylisting/Index';
import { Index as PropertyInquiries} from './propertyinquiries/Index';

export const RealProperty = ({ match }) => {
    const method = new URLSearchParams(window.location.search).get('method');
	const nav = useHistory();
	const handleChangeTabs = (_, newVal) => {
		nav.push(`/realproperty/${newVal}`)
	}	

	return (
		<Box p="0rem 1.5rem 1rem" /*sx={{ background: match.params.type === 'setup' ? 'linear-gradient(135deg, #e0f7fa, #fff)' : 'transparent' }}*/>
            <>
                { ( match.params.type !== 'setup' && method !== 'update' ) &&
                    <>		
                        <Typography fontSize="1.5rem" fontWeight="700" mb="0.5rem" mt="1rem">
                            Real Property
                        </Typography>
                        <Tabs value={match.params.type} onChange={handleChangeTabs}>
                            <Tab label="My Property Listing" value='property-listing'/>
                            <Tab label="Requested Listing" value='requested-listing'/>
                            <Tab label="Agent Application" value='agent-application'/>
                            <Tab label="Inquiries" value='inquiries'/>
                            <Tab label="Property Inquiries" value='property-inquiries'/>
                        </Tabs>
                    </>	
                }
                {
                    match.params.type === 'property-listing' || match.params.type === 'setup' ? <MyPropertyListing match={match}/>
                    : 	
                    match.params.type === 'requested-listing' ? <RequestedListing method={method}/> 
                    :	
                    match.params.type === 'agent-application' ? <AgentApplication/> 
                    :	
                    match.params.type === 'inquiries' ? <Inquiries/>
                    :
                    match.params.type === 'property-inquiries' ? <PropertyInquiries/>
                    :
                    <Box> Oops! Looks like you're lost. Page not found! </Box> 
                }
            </>
		</Box>
	);
};
